


































import { Component, Vue } from "vue-property-decorator";
import CheckinAssignments from "/src/components/home-page/CheckinAssignments.vue";
import WebinarsTimetable from "/src/components/home-page/WebinarsTimetable.vue";
import Unpublished from "@/components/home-page/Unpublished.vue";
import Courses from "@/components/home-page/Courses.vue";
import webinars, { WebinarsListParams } from "@/getinfo-api/webinars";
import { getCurrentEmployee, isRoot } from "@/plugins/roles";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { WebinarList as IWebinarList } from "@/api/models/webinar-list";
import course, { CourseListParams } from "@/getinfo-api/course";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { Course as ICourse } from "@/api/models/course";
import lectures, { LectureListParams } from "@/getinfo-api/lectures";
import { LecturesList as ILecturesList } from "@/api/models/lectures-list";
import { Lecture as ILecture } from "@/api/models/lecture";
import video, { VideoListParams } from "@/getinfo-api/video";
import { VideoList as IVideoList } from "@/api/models/video-list";
import { Video as IVideo } from "@/api/models/video";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { CourseUnionList } from "@/api/models/course-union-list";

@Component({
  components: {
    CheckinAssignments,
    WebinarsTimetable,
    Unpublished,
    Courses
  }
})
export default class HomePageContentManager extends Vue {
  courses: Array<ICourse> = [];
  webinars: Array<IWebinar> = [];
  lectures: Array<ILecture> = [];
  videos: Array<IVideo> = [];
  ownerId!: string | undefined;
  coursesDisabledCount: Array<ICourse> = [];
  webinarDisabledCount: Array<IWebinar> = [];
  lectureDisabledCount: Array<ILecture> = [];
  videosDisabledCount: Array<IVideo> = [];
  courseCount!: number;
  lecturesCount!: number;
  webinarsCount!: number;
  videosCount!: number;
  searchTitle!: string | undefined;
  limitedUsers: Array<ICourseListener> = [];
  listenerCount!: number;
  course!: string;

  data() {
    return {
      course: undefined,
      listenerCount: undefined,
      searchTitle: undefined,
      coursesDisabledCount: undefined,
      webinarDisabledCount: undefined,
      lectureDisabledCount: undefined,
      videosDisabledCount: undefined,
      webinarsCount: undefined,
      courseCount: undefined,
      lecturesCount: undefined,
      videosCount: undefined,
      ownerId: undefined
    };
  }

  getVideos() {
    let params: VideoListParams = {
      companyId: this.selectedCompanyId,
      title: this.searchTitle ? this.searchTitle : undefined
    };
    video(params).then((res: { data: IVideoList }) => {
      this.videos = [...this.videos, ...res.data.videos];
      this.videosDisabledCount = res.data.videos.filter(el => !el.enabled);
      this.videosCount = res.data.count;
    });
  }

  getLectures() {
    let params: LectureListParams = {
      companyId: this.selectedCompanyId
    };
    lectures(params).then((res: { data: ILecturesList }) => {
      this.lectures = [...this.lectures, ...res.data.lectures];
      this.lectureDisabledCount = res.data.lectures.filter(el => !el.enabled);
      this.lecturesCount = res.data.count;
    });
  }

  getWebinars() {
    let params: WebinarsListParams = {
      companyId: this.selectedCompanyId
    };
    webinars(params).then((res: { data: IWebinarList }) => {
      this.webinars = [
        ...this.webinars,
        ...res.data.webinars.filter(
          el => el.status === "coming" || el.status === "running"
        )
      ];
      this.webinarDisabledCount = res.data.webinars.filter(el => !el.enabled);
      this.webinarsCount = res.data.count;
    });
  }

  getCourses() {
    let params: CourseListParams = {
      companyIds: [this.selectedCompanyId],
      limit: 30
    };
    course(params).then((res: { data: CourseUnionList }) => {
      this.courses = [...this.courses, ...res.data.courses];
      this.coursesDisabledCount = res.data.courses.filter(el => !el.enabled);
      this.courseCount = res.data.count;
    });
  }

  get selectedCompanyId() {
    return this.$store.getters.selectedCompany.id;
  }

  get root() {
    return isRoot();
  }

  get contentManager() {
    return this.currentEmployee?.roles.includes("content_manager");
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  mounted() {
    setTimeout(() => {
      this.getWebinars();
      this.getCourses();
      this.getLectures();
      this.getVideos();
    }, 1500);
  }
}
